let IMG_URL = 'https://activity-web.wufan88.com/2022/shop_images';

const detailsList = {
    // 品版LOGO设计
    'brand_1':{  
        id: 1,
        icon:  IMG_URL+'/brand/icon/icon_1.gif',     // 图片
        name: '企业产品画册三折页台历宣传册封面宣传品书籍菜谱PPT平面设计',      // 名称
        label:['设计灵魂','高质量创意','售后保障'],     // 标签
        price: 1000,        // 价格
        score: 4.8,         // 评分
        cycle: 2,           // 周期
        answer: 1.5,        // 响应时间
        content:[
            IMG_URL+'/brand/img/p1/p_1.jpg',
            IMG_URL+'/brand/img/p1/p_2.gif',
            IMG_URL+'/brand/img/p1/p_3.gif',
        ],
    },
    'brand_2':{  
        id: 2,
        icon:  IMG_URL+'/brand/icon/icon_2.jpg', 
        name: '企业画册设计产品手册宣传册设计台历菜单三折页PPT公司排版',
        label:['48H出稿','十年实体','保证完成'],
        price: 1200,
        score: 4.8,
        cycle: 3,
        answer: 2,
        content:[
            IMG_URL+'/brand/img/p2/p_1.jpg',
        ],
    },
    'brand_3':{  
        id: 3,
        icon:  IMG_URL+'/brand/icon/icon_3.jpg', 
        name: '说明书设计/宣传册设计/产品说明书/医疗保健说明书',
        label:['先锋设计','售后保专业产品说明障'],
        price: 1000,
        score: 4.9,
        cycle: 3,
        answer: 2,
        content:[
            IMG_URL+'/brand/img/p3/p_1.jpg',
            IMG_URL+'/brand/img/p3/p_2.jpg',
        ],
    },
    'brand_4':{  
        id: 4,
        icon:  IMG_URL+'/brand/icon/icon_4.gif', 
        name: '画册设计产品公司宣传册杂志内刊会刊彩页三折页封套招商手册排版',
        label:['超级定制','满意修改','支持各类演示'],
        price: 600,
        score: 5,
        cycle: 1,
        answer: 1,
        content:[
            IMG_URL+'/brand/img/p4/p_1.jpg',
            IMG_URL+'/brand/img/p4/p_2.jpg',
            IMG_URL+'/brand/img/p4/p_3.jpg',
        ],
    },
    'brand_5':{  
        id: 5,
        icon:  IMG_URL+'/brand/icon/icon_5.jpg', 
        name: '企业产品画册三折页台历宣传册封面宣传品书籍菜谱PPT平面设计',
        label:['设计灵魂','高质量创意','售后保障'],
        price: 1000,
        score: 4.8,
        cycle: 2,
        answer: 1.5,
        content:[
            IMG_URL+'/brand/img/p5/p_1.jpg',
            IMG_URL+'/brand/img/p5/p_2.jpg',
            IMG_URL+'/brand/img/p5/p_3.jpg',
            IMG_URL+'/brand/img/p5/p_4.jpg',
        ],
    },
    'brand_6':{  
        id: 6,
        icon:  IMG_URL+'/brand/icon/icon_6.jpg', 
        name: '吉祥物设计Q版卡通IP造型公仔玩偶形象动态微信表情包盲盒设计',
        label:['多套方案','十二年经验','精美设计'],
        price: 1400,
        score: 4.8,
        cycle: 2,
        answer: 0.5,
        content:[
            IMG_URL+'/brand/img/p6/p_1.jpg',
        ],
    },
    'brand_7':{  
        id: 7,
        icon:  IMG_URL+'/brand/icon/icon_7.jpg', 
        name: '书籍排版 教材排版 画册排版 图书排版 杂志排版 期刊排版',
        label:['专精排版','创新'],
        price: 400,
        score: 5,
        cycle: 1,
        answer: 1,
        content:[
            IMG_URL+'/brand/img/p7/p_1.jpg',
            IMG_URL+'/brand/img/p7/p_2.jpg',
            IMG_URL+'/brand/img/p7/p_3.jpg',
            IMG_URL+'/brand/img/p7/p_4.jpg',
        ],
    },
    'brand_8':{  
        id: 8,
        icon:  IMG_URL+'/brand/icon/icon_8.jpg', 
        name: '门头招牌电梯广告牌灯箱广告单立柱广告牌设计',
        label:['地铁灯箱','社区灯箱','门头招牌'],
        price: 1500,
        score: 4.5,
        cycle: 3,
        answer: 1,
        content:[
            IMG_URL+'/brand/img/p8/p_1.gif',
            IMG_URL+'/brand/img/p8/p_2.gif',
        ],
    },
    'brand_9':{  
        id: 9,
        icon:  IMG_URL+'/brand/icon/icon_9.jpg', 
        name: '视频制作企业宣传广告制作产品宣传片企业年会视频剪辑特效制作',
        label:['包配音','专业案例','不限修改次数'],
        price: 1000,
        score: 4.8,
        cycle: 0.5,
        answer: 2,
        content:[
            IMG_URL+'/brand/img/p9/p_1.jpg',
            IMG_URL+'/brand/img/p9/p_2.jpg',
            IMG_URL+'/brand/img/p9/p_3.jpg',
            IMG_URL+'/brand/img/p9/p_4.jpg',
        ],
    },
    'brand_10':{  
        id: 10,
        icon:  IMG_URL+'/brand/icon/icon_10.jpg', 
        name: '开场动画年会视频大事记主视觉倒计时启动暖场发布会',
        label:['视频全案','企业文化体现'],
        price: 3000,
        score: 5,
        cycle: 3,
        answer: 1.5,
        content:[
            IMG_URL+'/brand/img/p10/p_1.png',
            IMG_URL+'/brand/img/p10/p_2.gif',
            IMG_URL+'/brand/img/p10/p_3.gif',
        ],
    },
    'brand_11':{  
        id: 11,
        icon:  IMG_URL+'/brand/icon/icon_11.jpg', 
        name: '食品饮料包装盒设计产品包装袋手提袋礼盒设计瓶贴茶业标签设计',
        label:['保证原创','服务多年','不限修改次数'],
        price: 1200,
        score: 4.9,
        cycle: 2,
        answer: 1.5,
        content:[
            IMG_URL+'/brand/img/p11/p_1.jpg',
            IMG_URL+'/brand/img/p11/p_2.jpg',
            IMG_URL+'/brand/img/p11/p_3.jpg',
            IMG_URL+'/brand/img/p11/p_4.jpg',
        ],
    },
    'brand_12':{  
        id: 12,
        icon:  IMG_URL+'/brand/icon/icon_12.jpg', 
        name: '包装盒绘插画食品零食瓶贴标签手提袋产品外包装盒包装袋包装设计',
        label:['创意提供','修改至满意'],
        price: 2000,
        score: 4.8,
        cycle: 2,
        answer: 1,
        content:[
            IMG_URL+'/brand/img/p12/p_1.jpg',
            IMG_URL+'/brand/img/p12/p_2.jpg',
            IMG_URL+'/brand/img/p12/p_3.jpg',
        ],
    },
    'brand_13':{  
        id: 13,
        icon:  IMG_URL+'/brand/icon/icon_13.jpg', 
        name: '原创系列包装设计大米插画口罩食品农产品茶叶手绘logo化妆品',
        label:['专业设计','原创案例','支持多次修改'],
        price: 900,
        score: 4.9,
        cycle: 2.5,
        answer: 2,
        content:[
            IMG_URL+'/brand/img/p13/p_1.jpg',
            IMG_URL+'/brand/img/p13/p_2.jpg',
            IMG_URL+'/brand/img/p13/p_3.jpg',
            IMG_URL+'/brand/img/p13/p_4.jpg',
        ],
    },
    'brand_14':{  
        id: 14,
        icon:  IMG_URL+'/brand/icon/icon_14.jpg', 
        name: '宣传品海报主KV全画幅DM宣传单品牌PPT展示招生招聘吊牌',
        label:['爆款打造','一站服务'],
        price: 400,
        score: 4.9,
        cycle: 2,
        answer: 2,
        content:[
            IMG_URL+'/brand/img/p14/p_1.jpg',
            IMG_URL+'/brand/img/p14/p_2.jpg',
        ],
    },
    'brand_15':{  
        id: 15,
        icon:  IMG_URL+'/brand/icon/icon_15.jpg', 
        name: '活动海报设计宣传单彩页插画单页平面图片门头贺卡展架广告设计',
        label:['品牌策划','辨识度',''],
        price: 1000,
        score: 4.8,
        cycle: 1,
        answer: 2,
        content:[
            IMG_URL+'/brand/img/p15/p_1.jpg',
        ],
    },
    'brand_16':{  
        id: 16,
        icon:  IMG_URL+'/brand/icon/icon_16.jpg', 
        name: '易拉宝门型展架x型展架宣传户外广告喷绘写真印刷设计制作',
        label:['高手设计','总监操刀',''],
        price: 1000,
        score: 4.9,
        cycle: 2,
        answer: 2,
        content:[
            IMG_URL+'/brand/img/p16/p_1.jpg',
            IMG_URL+'/brand/img/p16/p_2.jpg',
            IMG_URL+'/brand/img/p16/p_3.jpg',
            IMG_URL+'/brand/img/p16/p_4.jpg',
        ],
    },
    'brand_17':{  
        id: 17,
        icon:  IMG_URL+'/brand/icon/icon_17.jpg', 
        name: '企业画册产品手册宣传册设计公司画册设计书籍排版设计',
        label:['一对一服务','可一站印刷'],
        price: 1500,
        score: 4.7,
        cycle: 2,
        answer: 2,
        content:[
            IMG_URL+'/brand/img/p17/p_1.jpg',
        ],
    },
    'brand_18':{  
        id: 18,
        icon:  IMG_URL+'/brand/icon/icon_18.jpg', 
        name: '海报设计楼盘展示会展招商商务合作公益宣传宣传品展架易拉宝设计',
        label:['招商画册','专业洞察'],
        price: 980,
        score: 4.8,
        cycle: 2,
        answer: 2.5,
        content:[
            IMG_URL+'/brand/img/p18/p_1.jpg',
            IMG_URL+'/brand/img/p18/p_2.jpg',
            IMG_URL+'/brand/img/p18/p_3.jpg',
            IMG_URL+'/brand/img/p18/p_4.jpg',
            IMG_URL+'/brand/img/p18/p_5.jpg',
        ],
    },
    'brand_19':{  
        id: 19,
        icon:  IMG_URL+'/brand/icon/icon_19.jpg', 
        name: 'logo设计原创商标平面企业卡通图文品牌全案公司标志字体',
        label:['专注logo','品牌全案'],
        price: 800,
        score: 4.9,
        cycle: 2,
        answer: 2.5,
        content:[
            IMG_URL+'/brand/img/p19/p_1.jpg',
            IMG_URL+'/brand/img/p19/p_2.jpg',
            IMG_URL+'/brand/img/p19/p_3.jpg',
        ],
    },
    'brand_20':{  
        id: 20,
        icon:  IMG_URL+'/brand/icon/icon_20.jpg', 
        name: '企业文化墙设计公司前台走廊背景墙导视政府党建宣传栏形象墙橱窗',
        label:['3套方案可选','一对一服务'],
        price: 700,
        score: 4.9,
        cycle: 4,
        answer: 2,
        content:[
            IMG_URL+'/brand/img/p20/p_1.jpg',
            IMG_URL+'/brand/img/p20/p_2.jpg',
        ],
    },
    // 软件服务
    'serve_1':{  
        id: 1,
        icon:  IMG_URL+'/serve/icon/icon_1.jpg', 
        name: '企业网站/python/品牌官网/模板建站/公司官网/响应式',
        label:['低成本搭建','免费维护一年'],
        price: 3200,
        score: 5,
        cycle: 3,
        answer: 2,
        content:[
            IMG_URL+'/serve/img/p1/p_1.jpg',
            IMG_URL+'/serve/img/p1/p_2.jpg',
            IMG_URL+'/serve/img/p1/p_3.jpg',
        ],
    },
    'serve_2':{  
        id: 2,
        icon:  IMG_URL+'/serve/icon/icon_2.jpg', 
        name: '企业网站/python/品牌官网/模板建站/公司官网/响应式',
        label:['低成本搭建','免费维护一年'],
        price: 3200,
        score: 5,
        cycle: 3,
        answer: 2,
        content:[
            IMG_URL+'/serve/img/p2/p_1.jpg',
            IMG_URL+'/serve/img/p2/p_2.jpg',
            IMG_URL+'/serve/img/p2/p_3.jpg',
            IMG_URL+'/serve/img/p2/p_4.jpg',
            IMG_URL+'/serve/img/p2/p_5.jpg',
        ],
    },
    'serve_3':{  
        id: 3,
        icon:  IMG_URL+'/serve/icon/icon_3.jpg', 
        name: '政府网站 企业官网 教育网站 商城定制开发 模板建站',
        label:['支持三端建站','一年免费维护'],
        price: 3920,
        score: 4.7,
        cycle: 3,
        answer: 3,
        content:[
            IMG_URL+'/serve/img/p3/p_1.jpg',
        ],
    },
    'serve_4':{  
        id: 4,
        icon:  IMG_URL+'/serve/icon/icon_4.jpg', 
        name: '语音直播APP定制开发商城APP成品APP安卓开发IOS开发',
        label:['服务高效','售后安心'],
        price: 2400,
        score: 4.7,
        cycle: 3,
        answer: 2,
        content:[
            IMG_URL+'/serve/img/p4/p_1.jpg',
            IMG_URL+'/serve/img/p4/p_2.jpg',
            IMG_URL+'/serve/img/p4/p_3.jpg',
            IMG_URL+'/serve/img/p4/p_4.jpg',
        ],
    },
    'serve_5':{  
        id: 5,
        icon:  IMG_URL+'/serve/icon/icon_5.jpg', 
        name: '团购APP设计拼团APP小程序UI设计拼购商城拼团UI设计',
        label:['原创设计','10年经验'],
        price: 2000,
        score: 5,
        cycle: 3,
        answer: 2,
        content:[
            IMG_URL+'/serve/img/p5/p_1.jpg',
            IMG_URL+'/serve/img/p5/p_2.jpg',
            IMG_URL+'/serve/img/p5/p_4.jpg',
        ],
    },
    'serve_6':{  
        id: 6,
        icon:  IMG_URL+'/serve/icon/icon_6.jpg', 
        name: '区块链开发 dapp波场智能合约 以太智能合约',
        label:['专注区块链','创新赋能'],
        price: 3000,
        score: 4.9,
        cycle: 3,
        answer: 1.5,
        content:[
            IMG_URL+'/serve/img/p6/p_1.jpg',
            IMG_URL+'/serve/img/p6/p_2.jpg',
            IMG_URL+'/serve/img/p6/p_3.jpg',
            IMG_URL+'/serve/img/p6/p_4.jpg',
        ],
    },
    'serve_7':{  
        id: 7,
        icon:  IMG_URL+'/serve/icon/icon_7.jpg', 
        name: '为政府企业提供即时通讯sdk、im sdk接入',
        label:['快速接入','定制服务'],
        price: 1800,
        score: 4.8,
        cycle: 3,
        answer: 2,
        content:[
            IMG_URL+'/serve/img/p7/p_1.jpg',
            IMG_URL+'/serve/img/p7/p_2.jpg',
            IMG_URL+'/serve/img/p7/p_3.jpg',
        ],
    },
    'serve_8':{  
        id: 8,
        icon:  IMG_URL+'/serve/icon/icon_8.jpg', 
        name: '软件、SaaS服务、系统软件、数据库定制服务',
        label:['量身定做','源码交付'],
        price: 3000,
        score: 4.8,
        cycle: 3,
        answer: 2,
        content:[
            IMG_URL+'/serve/img/p8/p_1.jpg',
            IMG_URL+'/serve/img/p8/p_2.jpg',
            IMG_URL+'/serve/img/p8/p_3.jpg',
            IMG_URL+'/serve/img/p8/p_4.jpg',
            IMG_URL+'/serve/img/p8/p_5.jpg',
        ],
    },
    'serve_9':{  
        id: 9,
        icon:  IMG_URL+'/serve/icon/icon_9.jpg', 
        name: 'saas支付宝微信公众号小程序商城H5python开发定制',
        label:['满意为止','保证原创'],
        price: 21580,
        score: 4.9,
        cycle: 2,
        answer: 2,
        content:[
            IMG_URL+'/serve/img/p9/p_1.jpg',
            IMG_URL+'/serve/img/p9/p_2.jpg',
            IMG_URL+'/serve/img/p9/p_3.jpg',
            IMG_URL+'/serve/img/p9/p_4.jpg',
        ],
    },
    'serve_10':{  
        id: 10,
        icon:  IMG_URL+'/serve/icon/icon_10.jpg', 
        name: '微信会员营销系统注册模块软件积分兑换商城平台开发积分墙积分宝',
        label:['一对一服务协作','100+团队选择'],
        price: 3000,
        score: 4.9,
        cycle: 3,
        answer: 2,
        content:[
            IMG_URL+'/serve/img/p10/p_1.jpg',
            IMG_URL+'/serve/img/p10/p_2.jpg',
        ],
    },
    'serve_11':{  
        id: 11,
        icon:  IMG_URL+'/serve/icon/icon_11.jpg', 
        name: '公众号开发|微信定制开发|手机网站开发|微信商城 定制开发',
        label:['满意为止','资深团队'],
        price: 2800,
        score: 4.7,
        cycle: 3,
        answer: 3,
        content:[
            IMG_URL+'/serve/img/p11/p_1.jpg',
            IMG_URL+'/serve/img/p11/p_2.png',
            IMG_URL+'/serve/img/p11/p_3.png',
        ],
    },
    'serve_12':{  
        id: 12,
        icon:  IMG_URL+'/serve/icon/icon_12.jpg', 
        name: '手游游戏美术原画VR游戏场景外包休闲小游戏UI设计界面',
        label:['原创设计','48H出稿'],
        price: 3500,
        score: 5,
        cycle: 3,
        answer: 2,
        content:[
            IMG_URL+'/serve/img/p12/p_1.jpg',
            IMG_URL+'/serve/img/p12/p_2.jpg',
            IMG_URL+'/serve/img/p12/p_3.jpg',
            IMG_URL+'/serve/img/p12/p_4.jpg',
            IMG_URL+'/serve/img/p12/p_5.jpg',
        ],
    },
    'serve_13':{  
        id: 13,
        icon:  IMG_URL+'/serve/icon/icon_13.jpg', 
        name: '物联网定制物联网系统物联网APP智能硬件智慧软件工业物联网',
        label:['专业品质','10年开发'],
        price: 5000,
        score: 5,
        cycle: 4,
        answer: 2,
        content:[
            IMG_URL+'/serve/img/p13/p_1.jpg',
            IMG_URL+'/serve/img/p13/p_2.jpg',
        ],
    },
    'serve_14':{  
        id: 14,
        icon:  IMG_URL+'/serve/icon/icon_14.jpg', 
        name: 'app开发unity3D休闲单机游戏开发手机手游界面图标特效',
        label:['unity3D','无忧托管'],
        price: 6000,
        score: 4.8,
        cycle: 3,
        answer: 2.5,
        content:[
            IMG_URL+'/serve/img/p14/p_1.jpg',
            IMG_URL+'/serve/img/p14/p_2.jpg',
        ],
    },
    'serve_15':{  
        id: 15,
        icon:  IMG_URL+'/serve/icon/icon_15.jpg', 
        name: '旅行游戏文字游戏体感游戏游戏音乐游戏建造游戏竞速其它游戏开发',
        label:['按需定制','创意塑造'],
        price: 4000,
        score: 4.7,
        cycle: 3,
        answer: 2,
        content:[
            IMG_URL+'/serve/img/p15/p_1.jpg',
            IMG_URL+'/serve/img/p15/p_2.jpg',
            IMG_URL+'/serve/img/p15/p_3.jpg',
            IMG_URL+'/serve/img/p15/p_4.jpg',
            IMG_URL+'/serve/img/p15/p_5.jpg',
            IMG_URL+'/serve/img/p15/p_6.jpg',
        ],
    },
    'serve_16':{  
        id: 16,
        icon:  IMG_URL+'/serve/icon/icon_16.jpg', 
        name: '服务器运维/云产品安全代维优化/数据域名处理/服务器安全',
        label:['实力售后','丰富案例'],
        price: 15000,
        score: 4.6,
        cycle: 3,
        answer: 2,
        content:[
            IMG_URL+'/serve/img/p16/p_1.jpg',
            IMG_URL+'/serve/img/p16/p_2.jpg',
            IMG_URL+'/serve/img/p16/p_3.jpg',
            IMG_URL+'/serve/img/p16/p_4.jpg',
        ],
    },
    'serve_17':{  
        id: 17,
        icon:  IMG_URL+'/serve/icon/icon_17.jpg', 
        name: '成本管理软件开发/资产系统利润分析/成本数据展示/进销存可视化',
        label:['专业定制','24小时售后'],
        price: 3000,
        score: 4.8,
        cycle: 4,
        answer: 2,
        content:[
            IMG_URL+'/serve/img/p17/p_1.jpg',
            IMG_URL+'/serve/img/p17/p_2.jpg',
            IMG_URL+'/serve/img/p17/p_3.jpg',
            IMG_URL+'/serve/img/p17/p_4.jpg',
            IMG_URL+'/serve/img/p17/p_5.jpg',
            IMG_URL+'/serve/img/p17/p_6.jpg',
        ],
    },
    'serve_18':{  
        id: 18,
        icon:  IMG_URL+'/serve/icon/icon_18.jpg', 
        name: '外贸商城网站开发/国外电商独立站/多货币/英语法德意日韩西班',
        label:['面向外贸企业','营销一体'],
        price: 8000,
        score: 4.7,
        cycle: 4,
        answer: 1.5,
        content:[
            IMG_URL+'/serve/img/p18/p_1.jpg',
            IMG_URL+'/serve/img/p18/p_2.jpg',
            IMG_URL+'/serve/img/p18/p_3.jpg',
        ],
    },
    'serve_19':{  
        id: 19,
        icon:  IMG_URL+'/serve/icon/icon_19.jpg', 
        name: '软件开发定制企业CRM管理系统可视化数据工单ERP进销存模版',
        label:['软件即服务','专业技术'],
        price: 10000,
        score: 4.9,
        cycle: 4,
        answer: 2,
        content:[
            IMG_URL+'/serve/img/p19/p_1.jpg',
            IMG_URL+'/serve/img/p19/p_2.jpg',
            IMG_URL+'/serve/img/p19/p_3.jpg',
            IMG_URL+'/serve/img/p19/p_4.jpg',
            IMG_URL+'/serve/img/p19/p_5.jpg',
        ],
    },
    'serve_20':{  
        id: 20,
        icon:  IMG_URL+'/serve/icon/icon_20.jpg', 
        name: '微信小程序开发小程序商城点餐小程序团购分销拼团小程序定制',
        label:['后台稳定','私域流量'],
        price: 3000,
        score: 4.8,
        cycle: 3,
        answer: 2,
        content:[
            IMG_URL+'/serve/img/p20/p_1.jpg',
            IMG_URL+'/serve/img/p20/p_2.jpg',
            IMG_URL+'/serve/img/p20/p_3.jpg',
            IMG_URL+'/serve/img/p20/p_4.jpg',
        ],
    },
    // 电子商务
    'business_1':{  
        id: 1,
        icon:  IMG_URL+'/business/icon/icon_1.jpg', 
        name: '淘宝天猫代运营拼多多店铺运营电商京东钻展直通车托管网店代运营',
        label:['一站权代理','百家品牌信赖'],
        price: 10000,
        score: 4.8,
        cycle: 3,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p1/p_1.jpg',
            IMG_URL+'/business/img/p1/p_2.jpg',
            IMG_URL+'/business/img/p1/p_3.jpg',
            IMG_URL+'/business/img/p1/p_4.jpg',
            IMG_URL+'/business/img/p1/p_5.jpg',
            IMG_URL+'/business/img/p1/p_6.jpg',
        ],
    },
    'business_2':{  
        id: 2,
        icon:  IMG_URL+'/business/icon/icon_2.jpg', 
        name: '直通车图设计制作宝贝主图设计产品主图设计活动主图设计淘宝天猫',
        label:['高性价比','高效出片'],
        price: 1000,
        score: 5,
        cycle: 3,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p2/p_1.jpg',
            IMG_URL+'/business/img/p2/p_2.jpg',
            IMG_URL+'/business/img/p2/p_3.jpg',
            IMG_URL+'/business/img/p2/p_4.jpg',
            IMG_URL+'/business/img/p2/p_5.jpg',
            IMG_URL+'/business/img/p2/p_6.jpg',
        ],
    },
    'business_3':{  
        id: 3,
        icon:  IMG_URL+'/business/icon/icon_3.jpg', 
        name: '品牌命名企业公司改名取名网站店铺产品商标起名',
        label:['不限修改次数','5套方案可选'],
        price: 1000,
        score: 4.0,
        cycle: 2,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p3/p_1.jpg',
            IMG_URL+'/business/img/p3/p_2.jpg',
            IMG_URL+'/business/img/p3/p_3.jpg',
            IMG_URL+'/business/img/p3/p_4.jpg',
            IMG_URL+'/business/img/p3/p_5.jpg',
        ],
    },
    'business_4':{  
        id: 4,
        icon:  IMG_URL+'/business/icon/icon_4.jpg', 
        name: '天猫入驻网店运营淘宝店铺代运营直通车托管淘宝运营代运营淘宝',
        label:['匠心专注','释放品牌力量'],
        price: 6500,
        score: 4.9,
        cycle: 1,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p4/p_1.jpg',
            IMG_URL+'/business/img/p4/p_2.jpg',
            IMG_URL+'/business/img/p4/p_3.jpg',
        ],
    },
    'business_5':{  
        id: 5,
        icon:  IMG_URL+'/business/icon/icon_5.jpg', 
        name: 'ps修图 网站美工修图 照片模糊修清晰 电商图片处理 抠图',
        label:['一对一服务','满意为止'],
        price: 800,
        score: 4.8,
        cycle: 1,
        answer: 3,
        content:[
            IMG_URL+'/business/img/p5/p_1.jpg',
            IMG_URL+'/business/img/p5/p_2.jpg',
            IMG_URL+'/business/img/p5/p_3.jpg',
        ],
    },
    'business_6':{  
        id: 6,
        icon:  IMG_URL+'/business/icon/icon_6.jpg', 
        name: '淘宝京东产品拍摄照片精修处理产品摄影电商拍照场景拍照白底图',
        label:['全网电子商务'],
        price: 100,
        score: 4.9,
        cycle: 2,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p6/p_1.jpg',
            IMG_URL+'/business/img/p6/p_2.jpg',
            IMG_URL+'/business/img/p6/p_3.jpg',
            IMG_URL+'/business/img/p6/p_4.jpg',
        ],
    },
    'business_7':{  
        id: 7,
        icon:  IMG_URL+'/business/icon/icon_7.jpg', 
        name: '产品动画 效果图渲染 三维动画 宣传视频 3D建模 电商主图',
        label:['品质拉满','效率起飞'],
        price: 800,
        score: 4.7,
        cycle: 3,
        answer: 3,
        content:[
            IMG_URL+'/business/img/p7/p_1.jpg',
        ],
    },
    'business_8':{  
        id: 8,
        icon:  IMG_URL+'/business/icon/icon_8.jpg', 
        name: '电商策划店铺产品定位活动策划诊断网店策划装修风格设计首页商品',
        label:['品牌合伙人','业界好口碑'],
        price: 600,
        score: 5,
        cycle: 4,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p8/p_1.jpg',
            IMG_URL+'/business/img/p8/p_2.jpg',
            IMG_URL+'/business/img/p8/p_3.jpg',
            IMG_URL+'/business/img/p8/p_4.jpg',
        ],
    },
    'business_9':{  
        id: 9,
        icon:  IMG_URL+'/business/icon/icon_9.gif', 
        name: '天猫拼多多小程序美工包月美工外包亚马逊电商设计电商全店铺装修',
        label:['专业团队','美工包月'],
        price: 400,
        score: 4.9,
        cycle: 2,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p9/p_1.jpg',
            IMG_URL+'/business/img/p9/p_2.jpg',
            IMG_URL+'/business/img/p9/p_3.jpg',
            IMG_URL+'/business/img/p9/p_4.jpg',
            IMG_URL+'/business/img/p9/p_5.jpg',
            IMG_URL+'/business/img/p9/p_6.jpg',
        ],
    },
    'business_10':{  
        id: 10,
        icon:  IMG_URL+'/business/icon/icon_10.jpg', 
        name: '淘宝美工包月详情设计电商美工外包天猫京东店铺整店装修阿里巴巴',
        label:['星级服务','一站设计'],
        price: 3000,
        score: 4.9,
        cycle: 2,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p10/p_1.jpg',
            IMG_URL+'/business/img/p10/p_2.jpg',
            IMG_URL+'/business/img/p10/p_3.jpg',
        ],
    },
    'business_11':{  
        id: 11,
        icon:  IMG_URL+'/business/icon/icon_11.jpg', 
        name: '详情页设计产品详情页制作天猫店铺整店装修美工设计拼多多',
        label:['懂运营','高点击'],
        price: 6000,
        score: 4.8,
        cycle: 1,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p11/p_1.jpg',
            IMG_URL+'/business/img/p11/p_2.jpg',
            IMG_URL+'/business/img/p11/p_3.jpg',
            IMG_URL+'/business/img/p11/p_4.jpg',
            IMG_URL+'/business/img/p11/p_5.jpg',
        ],
    },
    'business_12':{  
        id: 12,
        icon:  IMG_URL+'/business/icon/icon_12.jpg', 
        name: '美工外包美工包月电商设计电商详情页设计首页修图海报店铺装修',
        label:['专业设计'],
        price: 2500,
        score: 4.8,
        cycle: 2,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p12/p_1.jpg',
            IMG_URL+'/business/img/p12/p_2.jpg',
            IMG_URL+'/business/img/p12/p_3.jpg',
        ],
    },
    'business_13':{  
        id: 13,
        icon:  IMG_URL+'/business/icon/icon_13.jpg', 
        name: '插画设计商业手绘国潮风卡通包装人动物绘本Q版漫画地图场景插图',
        label:['商业插画','案例全面'],
        price: 3000,
        score: 4.9,
        cycle: 2,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p13/p_1.jpg',
            IMG_URL+'/business/img/p13/p_2.jpg',
            IMG_URL+'/business/img/p13/p_3.jpg',
            IMG_URL+'/business/img/p13/p_4.jpg',
        ],
    },
    'business_14':{  
        id: 14,
        icon:  IMG_URL+'/business/icon/icon_14.jpg', 
        name: '网店电商京东自营入驻天猫旗舰店专卖专营代入驻代办开店铺下店',
        label:['0风险入驻','先完成后付款'],
        price: 5000,
        score: 4.9,
        cycle: 1,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p14/p_1.jpg',
            IMG_URL+'/business/img/p14/p_2.jpg',
            IMG_URL+'/business/img/p14/p_3.jpg',
            IMG_URL+'/business/img/p14/p_4.jpg',
            IMG_URL+'/business/img/p14/p_5.jpg',
        ],
    },
    'business_15':{  
        id: 15,
        icon:  IMG_URL+'/business/icon/icon_15.jpg', 
        name: '天猫京东拼多多飞猪极有家唯品会淘宝店铺代入驻商家入驻开店申请',
        label:['专业一对一','12年经验'],
        price: 3000,
        score: 4.9,
        cycle: 2,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p15/p_1.jpg',
            IMG_URL+'/business/img/p15/p_2.jpg',
            IMG_URL+'/business/img/p15/p_3.jpg',
        ],
    },
    'business_16':{  
        id: 16,
        icon:  IMG_URL+'/business/icon/icon_16.jpg', 
        name: '【聚划算】抖音淘宝、MV动画营销短视频动画企业产品宣传片动画',
        label:['赠送修图','不满意可退款'],
        price: 3000,
        score: 4.8,
        cycle: 2,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p16/p_1.jpg',
            IMG_URL+'/business/img/p16/p_2.jpg',
            IMG_URL+'/business/img/p16/p_3.jpg',
            IMG_URL+'/business/img/p16/p_4.jpg',
        ],
    },
    'business_17':{  
        id: 17,
        icon:  IMG_URL+'/business/icon/icon_17.jpg', 
        name: '天猫京东拼多多飞猪极有家唯品会淘宝店铺代入驻商家入驻开店申请',
        label:['资料齐全','成功再付款'],
        price: 4000,
        score: 4.7,
        cycle: 3,
        answer: 3,
        content:[
            IMG_URL+'/business/img/p17/p_1.jpg',
            IMG_URL+'/business/img/p17/p_2.jpg',
            IMG_URL+'/business/img/p17/p_3.jpg',
            IMG_URL+'/business/img/p17/p_4.jpg',
        ],
    },
    'business_18':{  
        id: 18,
        icon:  IMG_URL+'/business/icon/icon_18.jpg', 
        name: '淘宝天猫京东客服外包网店客服客服托管活动客服全天白班客服',
        label:['免费试用','全年无休'],
        price: 2000,
        score: 5,
        cycle: 2,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p18/p_1.jpg',
            IMG_URL+'/business/img/p18/p_2.jpg',
            IMG_URL+'/business/img/p18/p_3.jpg',
            IMG_URL+'/business/img/p18/p_4.jpg',
        ],
    },
    'business_19':{  
        id: 19,
        icon:  IMG_URL+'/business/icon/icon_19.jpg', 
        name: '食品详情页设计食品详情页制作食品专题页设计',
        label:['结果导向','高转化率'],
        price: 3000,
        score: 5,
        cycle: 2,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p19/p_1.jpg',
            IMG_URL+'/business/img/p19/p_2.jpg',
            IMG_URL+'/business/img/p19/p_3.jpg',
        ],
    },
    'business_20':{  
        id: 20,
        icon:  IMG_URL+'/business/icon/icon_20.jpg', 
        name: '详情页设计电商店铺装修旅游淘宝拼多多美团携程飞猪亚马逊高端',
        label:['效果出众','包文案拍照'],
        price: 6000,
        score: 4.8,
        cycle: 1.5,
        answer: 2,
        content:[
            IMG_URL+'/business/img/p20/p_1.jpg',
            IMG_URL+'/business/img/p20/p_2.jpg',
            IMG_URL+'/business/img/p20/p_3.gif',
            IMG_URL+'/business/img/p20/p_4.gif',
        ],
    },
}

export {
    detailsList, 
};